import { StudyTypes } from './types';

const { ADD_STUDY, ADD_CONTENT, ADD_CONTENT_ID, ADD_ACTIVE_STUDY, COMPLETE } = StudyTypes;

interface StudyState {
  study: any;
  content: string | any;
  activeStudy: string | boolean;
  contentId: string | any;
}

export const initialState: StudyState = {
  study: null,
  content: '',
  activeStudy: false,
  contentId: null,
};

// eslint-disable-next-line default-param-last
const studyReducer = (state = initialState, action: any): StudyState => {
  switch (action.type) {
    case ADD_STUDY: {
      return {
        ...state,
        study: action.payload,
      };
    }
    case ADD_ACTIVE_STUDY: {
      return {
        ...state,
        activeStudy: action.payload,
      };
    }
    case ADD_CONTENT: {
      return {
        ...state,
        content: action.payload,
      };
    }
    case ADD_CONTENT_ID: {
      return {
        ...state,
        contentId: action.payload,
      };
    }
    case COMPLETE: {
      // Not muttable, will fix later
      const newChapters: any = JSON.parse(JSON.stringify(state.study.book_chapters));
      newChapters.map(e => {
        const sections = e.sections.map(e => {
          if (e.title === state.activeStudy) {
            e.is_completed = true;
          }
          return e;
        });
        return sections;
      });
      return {
        ...state,
        study: {
          ...state.study,
          chapters: [...newChapters],
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default studyReducer;
